const BASE_API_URL = 'https://app.hidrata.ai'
const BASE_URL = 'http://palavras.ai'
export {BASE_API_URL, BASE_URL};